<template>
  <div class="app-community flex">
    <GfrLayoutAside class="app-community-menu" :data-state="showMenu ? 'open' : 'closed'">
      <div class="app-community-aside-inner">
        <div class="mb-4 flex items-center flex-shrink-0 max-lg:mb-2">
          <GfrNewButton class="app-toggle-btn lg:!hidden" @click="toggleCommunityMenu">
            <IconsReturn class="h-4 w-4 rotate-180" />
          </GfrNewButton>
        </div>
        <GfrScrollArea
          v-model:reset="resetScroll"
          class="app-docs-catalog-wrapper"
          :dir="$route.params.lang === 'ar' ? 'rtl' : 'ltr'"
        >
          <GfrCatalog
            :data="communityMenu"
            :active-url="String($route.params.category)"
            :show-obsoleted="false"
            :prefix-path="`/${$route.params.lang}/community`"
          />
        </GfrScrollArea>
      </div>
    </GfrLayoutAside>
    <section class="app-community-inner">
      <NuxtPage v-if="communityMenu.length" />
    </section>
  </div>
</template>

<script setup lang="ts">
const route = useRoute()
const communityStore = useCommunityStore()
const { toggleCommunityMenu, fetchCommunityData } = communityStore
const { showMenu, communityMenu } = storeToRefs(communityStore)

const resetScroll = ref(false)
await fetchCommunityData()

const autoPageJump = () => {
  if (communityMenu.value.length > 0) {
    // 如果没有 category 参数，且菜单有内容，跳转到第一个分类
    const firstCategory = communityMenu.value[0]?.url
    if (firstCategory) {
      navigateTo({
        path: `/${route.params.lang}/community/${firstCategory}`,
        replace: true
      })
    }
  }
}

watch(
  () => route.params.category,
  () => {
    showMenu.value && toggleCommunityMenu()
  }
)
onMounted(() => {
  if (!route.params.category) {
    autoPageJump()
  }
})
</script>

<style scoped lang="scss">
.app-community-inner {
  @apply lg:max-w-[calc(100%-380px)] w-full lg:pb-13 max-lg:pb-8 lg:pt-6 max-lg:pt-5 lg:pr-15 max-lg:pr-5 lg:pl-10 max-lg:pl-5;
}
.app-community-menu {
  // layout
  @apply lg:w-[380px];
  @apply max-lg:w-0;

  // spacing & position
  @apply max-2xl:px-5 relative lg:min-h-[calc(100vh-4.5rem)] z-20 lg:py-6;
  @apply ltr:2xl:pl-11 ltr:2xl:pr-6 rtl:2xl:pl-6 rtl:2xl:pr-11;
  @apply z-20 max-lg:fixed max-lg:left-0 max-lg:top-10 max-lg:h-[calc(100%-2.5rem)] max-lg:w-full max-lg:px-5 max-lg:py-3;

  // background overlay
  @apply after:absolute after:top-0 after:-z-10 after:h-full after:w-full after:bg-dark/40;
  @apply after:rtl:left-0 after:ltr:right-0 after:max-lg:bg-[#202227];

  // animation
  @apply transition-transform duration-500 ease-out data-[state=open]:pointer-events-auto ltr:max-lg:data-[state=closed]:-translate-x-full ltr:max-lg:data-[state=open]:translate-x-0 rtl:max-lg:data-[state=closed]:translate-x-full rtl:max-lg:data-[state=open]:translate-x-0;

  :deep(.gfr-catalog-header) {
    @apply py-1;
  }
}
.app-community-menu-inner {
  @apply flex lg:max-h-[calc(100vh-6.5rem)] w-[19.5rem] flex-col pb-7 lg:sticky lg:left-0 lg:top-24;
  @apply max-lg:w-full max-lg:h-full max-lg:max-h-[98%] max-lg:pb-2;
}
.app-toggle-btn {
  @apply inline-flex z-10 h-8 w-8 bg-dark-background ltr:mr-2 rtl:ml-2;
}
.app-community-aside-inner {
  @apply flex lg:max-h-[calc(100vh-6.5rem)] w-[19.5rem] flex-col pb-7 lg:sticky lg:left-0 lg:top-24;
  @apply max-lg:w-full max-lg:h-full max-lg:max-h-[98%] max-lg:pb-2;
}
</style>
